<app-metric-card
  [title]="cardTitle"
  [currentValue]="inProgressTicketData().value !== null ? inProgressTicketData().value : 0"
  [suffix]="suffix"
  [hidePrevious]="true"
  [hideComparison]="true"
  [isLoading]="isLoading()"
>
</app-metric-card>
